import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getAppChainId, getWalletChainId } from "../../shared/redux/selectors";
import { usePageAvailableNetworks } from '../../shared/api';

// import { useGovernanceSupportedChainIds } from "./useGovernanceSupportedChainIds";

export type UnsupportedNetworkLevel = 'wallet' | 'application' | 'notSynced';

export function useUnsupportedNetworkLevel(): ReturnType<typeof useState<UnsupportedNetworkLevel>> {
  const walletChainId = useSelector(getWalletChainId);
  const appChainId = useSelector(getAppChainId);
  const { supportedChainIds } = usePageAvailableNetworks();
  const [level, setLevel] = useState<UnsupportedNetworkLevel>();

  useEffect(() => {
    if (
      walletChainId === undefined ||
      supportedChainIds === undefined ||
      supportedChainIds.length === 0 ||
      supportedChainIds.includes(appChainId)
    ) {
      setLevel(undefined);
    } else if (
      !supportedChainIds.find(
        (chainId) => walletChainId === parseInt(chainId, 10),
      )
    ) {
      setLevel('wallet');
    } else if (!supportedChainIds.includes(appChainId)) {
      setLevel('application');
    } else if (parseInt(appChainId, 10) !== walletChainId) {
      setLevel('notSynced');
    } else {
      setLevel(undefined);
    }
  }, [appChainId, supportedChainIds, walletChainId]);

  return [level, setLevel];
}
